export default [
  {
    path: "quincena-veinticinco",
    name: "quincena-veinticinco",
    component: () => import("../views/ConfiguracionQuincenaVeinticinco.vue"),
  },
];
